namespace Matrix.Data {
    export class DataColumnListColumns {
        static columnsKey = 'Data.DataColumnList';
    }
}
